import { createAuthClient } from 'better-auth/client';
import {
    magicLinkClient,
    organizationClient,
    lastLoginMethodClient,
    twoFactorClient,
} from 'better-auth/client/plugins';
import { oauthProviderClient } from '@better-auth/oauth-provider/client';

export const BETTER_AUTH_UI_ENABLED = ['1', 'true', 'yes', 'on'].includes(
    (import.meta.env.VITE_BETTER_AUTH_UI_ENABLED || '').toLowerCase(),
);

export const BETTER_AUTH_BASE_PATH = '/auth';

export const betterAuthClient = createAuthClient({
    baseURL: import.meta.env.VITE_API_ROOT,
    basePath: BETTER_AUTH_BASE_PATH,
    fetchOptions: {
        credentials: 'include',
    },
    plugins: [
        magicLinkClient(),
        organizationClient({
            teams: { enabled: true },
        }),
        lastLoginMethodClient(),
        twoFactorClient({ twoFactorPage: '/auth/two-factor' }),
        oauthProviderClient(),
    ],
});
